import styled from 'styled-components'
import {maxWidth} from 'resources/react/core/theme'
import {darken} from 'polished'

export const Wrapper = styled.div`
    .header {
        display: flex;
        justify-content: center;
    }

    p {
        font-size: 20px;
        font-family: Lato;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.5;
        letter-spacing: normal;     
    }

    .button {
        padding: 10px !important;
        font-size: 13px;
        width: 159px;
        background: #09f;
        color: #fff;
        border: none;
        text-align: center;
    }

    h2 {
        font-size: 39px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.13;
        letter-spacing: normal;
        text-align: center;

        p {
            font-size: 39px;
        }
    }

    .button-orange {
        display: block;
        padding: 10px 0px;
        font-size: 13px !important;
        width: 159px;
        background: #fe5147;
        color: #fff;
        margin-top: 5px;
        text-align: center;
    }

    .accordion__text {
        p {
            margin: 0px;

        }
        a {
            font-size: 20px;
        }
    }    

    .button-wrap {
        display: flex;
        justify-content: center;
        margin: 30px 0px;
    }

    .section-1 {
        display: flex;
        justify-content: center;
        padding-top: 40px;
        padding-bottom: 80px;

        .text-wrap > p {
            padding-bottom: 5px;
        }

        .text-wrap {
            p {
                margin: 0px;
            }

            a {
                font-size: 20px;
            }            

            h2 {
                text-align: left;
                margin-top: 0px;
            }

            max-width: 588px;
            padding-left: 25px;
        }
    }

    .mobile-slider {
        .slick-track {
            margin-left: 70px;
        }
    }

    .section-1-img {
        width: 384px;
        height: 384px;
    }

    .section-2-img {
        width: 275px;
    }

    .section-2 {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 40px;
        background-color: #f8f8f8;
        font-family: Lato;

        .slider-wrap {
            display: none;
        }

        h2 {
            font-family: Merriweather;
            color: #003594;
        }

        .img-wrap {
            display: flex;
            justify-content: space-evenly;

            .wrap {
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

                .wrap-text {
                    font-size: 16px;
                    text-align: center;
                    width: 588px;

                    p {
                        font-size: 16px;
                    }
                }
            }
        }
    } 

    .wrap-title {
        margin: 24px 0 16px;
        font-family: Lato;
        font-size: 25px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.28;
        letter-spacing: normal;
        text-align: center;
        color: #007acc;
    }

    .accordion__content {
        border-bottom: 1px solid #000;
        background-color: #f8f8f8;
    }

    .accordion-wrap {
        display: flex;
        justify-content: center;
        flex-direction: column;
        margin-left: 60px;

        div {
            color: #000;
            width: 1088px;
        }
    }
    
    .section-3 {
        padding: 50px 0px;
    }

        h2 {
            text-align: center;
        }
    }

    .mobile-slider {
        display: none;
    }

    .img-row {
        display: flex;
        justify-content: space-evenly;
        padding-top: 20px;

        .img-row-box {
            width: 282px;
            border: solid 1px #eaeaea;
            border-bottom: 4px solid #eaeaea;
        }

        .img-row-box-text {
            display: block;
            height: 24px;
            margin: 16px 20px 16px 16px;
            font-family: Lato;
            font-size: 20px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #007acc;
        }

        img {
            width: 282px
        }

        p {
            max-width: 100%;
        }
    }    

    .section-4 {
        h2 {
            text-align: center;
        }
    }

    .section-7 {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 85px;
        margin-top: 50px;
    }
    
    h3 {
        margin: 40px 0 15px;
        padding: 0;
    }

    ${maxWidth.small`

        img {
            height: 100% !important;
        }    

        .next_arrow {
            display: block;
            font-size: 30px;
            position: absolute;
            z-index: 999;
            right: 33% !important;
            top: 99%;
            transform: rotate(90deg);
            cursor: pointer;
            color: #bababa;
        }    

    `}
    ${maxWidth.medium`
        .accordion__text {
            p {
                font-size: 16px;
            }
        }

        .accordion__title {
            font-size: 16px !important;
        }     
        .section-4,
        .section-5,
        .section-6 {
            .slick-dots {
                top: 279px;
            }
        }

        .slick-track {
            padding-bottom: 20px;
        }

        .slick-data {
            height: 25px;
        }

        .slick-dots > li {
            width: 9px;
        }
    
        .next_arrow:hover, .prev_arrow:hover {
            color: #007acc;
        }

        .next_arrow {
            display: block;
            font-size: 30px;
            position: absolute;
            z-index: 999;
            right: 35%;
            top: 99%;
            transform: rotate(90deg);
            cursor: pointer;
            color: #bababa;
        }

        .prev_arrow {
            display: block;
            font-size: 30px;
            position: absolute;
            z-index: 999;
            left: 35%;
            top: 99%;
            transform: rotate(-90deg);
            cursor: pointer;
            color: #bababa;
        }        

        p {
            font-size: 18px;
        }

        h2 {
            font-size: 31px;
        }

        .accordion-wrap {
            
            margin-left: 0px;

            div {
                width: 100%;
            }
        }

        .img-row {
            display: none !important;
        }

        .mobile-slider {
            display: block;
            padding-top: 20px;

            .mobile-box {
                width: 282px;
                border: solid 1px #eaeaea;
            }

            .mobile-box-text {
                display: block;
                height: 24px;
                margin: 16px 20px 16px 16px;
                font-family: Lato;
                font-size: 20px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #007acc;
            }

            img {
                width: 282px
            }

            p {
                max-width: 100%;
            }
        }    

        .anchored-nav {
            width: 320px !important;
        }

        .header {
            justify-content: left;
            padding-left: 15px;
            padding-right: 15px;
        }

        .section-1 {
            flex-direction: column;
        }

        .section-1 {
            padding-left: 15px;
            padding-right: 15px;

            .img-wrap {
                display: flex;
                justify-content: center;
            }

            .text-wrap {
                max-width: 100%;
                padding-left: 0px;
                padding-top: 25px;
                line-height: 24px;
            }
        }

        .section-2 {
            padding-left: 15px;
            padding-right: 15px;
            flex-direction: column;
            padding-bottom: 20px;
            background-color: #fff;

            .slider-wrap {
                display: block;
            }

            h2 {
                text-align: center;
                font-family: Merriweather;
                font-size: 31px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.19;
                letter-spacing: normal;
                text-align: center;
                color: #003594;                
            }

            .img-wrap {
                display: none;
            }

            .wrap {
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 20px;
            }

            .text-wrap {
                line-height: 24px;
                max-width: 100%;
                padding-top: 25px;
            }
        }

        .section-3 {
            padding-left: 15px;
            padding-right: 15px;

            h2 {
                text-align: left;
            }

            .img-wrap {
                display: none;
            }
        }

        .section-5,
        .section-6 {
            margin-top: 70px;
        }
    `}
`